import { addParam } from '@shell/utils/url';
import { ucFirst } from '@shell/utils/string';
import NormanModel from '@shell/plugins/steve/norman-class';

export default class Principal extends NormanModel {
  get avatarSrc() {
    if (this.profilePicture) {
      return this.provider === 'github' ? addParam(this.profilePicture, 's', 80) : this.profilePicture;
    }

    return require('@shell/assets/icons/carbon/user.svg');
  }

  get roundAvatar() {
    return !!this.profilePicture;
  }

  get providerSpecificType() {
    const parts = this.id.replace(/:.*$/, '').split('_', 2);

    if ( parts.length === 2 ) {
      return parts[1];
    }

    return null;
  }

  get displayType() {
    const provider = this.$rootGetters['i18n/withFallback'](`model.authConfig.provider."${ this.provider }"`, null, this.provider);

    return `${ provider } ${ ucFirst(this.providerSpecificType) }`;
  }
}
